<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <div class="modal-close" @click="$emit('close')"></div>
            <h3>{{ modalTitle }}</h3>
          </div>

          <div class="modal-body">
            <slot/>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: [ 'modalTitle' ],
  name: 'Modal',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(26, 35, 126, .7);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 45%;
  margin: 0px auto;
  background: none;
  border-radius: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  position: relative;
  padding: 29px 40px 25px;
  background-color: $primary-beta;
  border-radius: 15px 15px 0 0;
  color: $text-light;

  h3 {
    @extend %type-gamma;
    font-size: 24px;
    color: $text-light;
    margin: 0;
  }
}

.alert {
  .modal-header {
    background-color: $secondary-dark;

    h3 {
      padding-left: 30px;
      background: url('../assets/icons/warning.png') no-repeat top left;
    }
  }
  a.button {
    background-color: $surface-theta;
    color: $text-beta;
    margin-bottom: 40px;
  }
}

.modal-close {
  position: absolute;
  background: url('../assets/icons/modal-close.png') no-repeat;
  width: 16px;
  height: 16px;
  top: 15px;
  right: 15px;
}

.modal-body {
  background-color: #fff;
  border-radius: 0 0 15px 15px;
  padding: 25px 0px;
}

/*
 * Transition fun
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
